/**
 * Public pages the portal links to. They live in bodyprint-web; the partner terms text is still
 * to be confirmed (docs/init/06-implementacao.md).
 */
export const BODYPRINT_PRIVACY_URL = 'https://app.bodyprint.com.br/privacy';
